import React, { useState } from "react";
import {Outlet, Link, useLocation } from "react-router-dom";
import './Blog.css';
import Footer from "../components/Footer";

const Blog = () =>{

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    return(
        <section className="container-blog"
            style={{ overflow: 'hidden'}}
        >
            <div className="navbar-blog"
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/blog-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu} >
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
    
                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                    <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                    <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                </nav>
    
                {/* Hexagon Nav (desktop) */}
                <section className="hero--inner">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                </section>
            </div>
            <div
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/blog-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
            <div className="blog-container">
                <h1>Reparatur und Wartung aller Marken – Qualität, auf die Sie sich verlassen können</h1>
                <h2>Reparatur und Wartung aller Marken – Ihre Werkstatt für alle Fälle</h2>
                <p>
                    Egal ob VW, BMW, Mercedes, Toyota oder Audi – wir sind Ihre markenunabhängige 
                    Werkstatt in NRW, die Qualität großschreibt. Unser erfahrenes Team kümmert sich 
                    um die fachgerechte Wartung und Reparatur Ihres Fahrzeugs – unabhängig vom Hersteller. 
                    Dabei setzen wir auf modernste Technik, geschultes Personal und höchste Sorgfalt.
                    Regelmäßige Wartung erhöht nicht nur die Lebensdauer Ihres Autos, sondern senkt auch 
                    Folgekosten durch frühzeitige Fehlererkennung. 
                    Unsere Werkstatt arbeitet transparent, zuverlässig und zu fairen Preisen. 
                    Wir dokumentieren jede Maßnahme und beraten Sie ausführlich – damit Sie jederzeit 
                    sicher und entspannt unterwegs sind.
                </p>
                <h1>Unfallinstandsetzung – Schnell wieder mobil nach dem Crash</h1>
                <h2>Unfallinstandsetzung vom Profi – Wir bringen Ihr Auto wieder in Bestform</h2>
                <p>
                   Ein Unfall ist schnell passiert – wir kümmern uns darum, dass Ihr Fahrzeug fachmännisch und zuverlässig 
                   instand gesetzt wird. Ob kleiner Blechschaden oder umfangreiche Karosseriearbeiten: 
                   Unsere Werkstatt bietet Ihnen einen Rundum-Service von der Schadensanalyse über die Reparatur bis
                    hin zur Abwicklung mit der Versicherung.
                   Dank präziser Arbeit, hochwertiger Ersatzteile und modernster Technik sehen wir nicht nur den Schaden,
                    sondern auch das, was dahintersteckt. Ihr Auto soll nicht nur gut aussehen – es soll auch sicher 
                    und technisch einwandfrei auf die Straße zurückkehren.
                </p>
                <h1>Fehlerdiagnose – Wir finden, was andere übersehen</h1>
                <h2>Fehlerdiagnose mit System – Moderne Technik für klare Ergebnisse</h2>
                <p>
                    Das Auto blinkt, piept oder fährt nicht wie gewohnt? Mit unserer computergestützten Fehlerdiagnose gehen 
                    wir der Sache auf den Grund. Unsere Diagnosegeräte erkennen elektronisch gespeicherte Fehler in Motor, 
                    Getriebe, Bremsen, Abgasanlage und Co. – schnell, zuverlässig und exakt.
                    Gerade bei modernen Fahrzeugen mit komplexer Bordelektronik ist eine präzise Fehlerauswertung 
                    entscheidend für eine erfolgreiche Reparatur. Verlassen Sie sich auf unser Know-how und unsere 
                    Erfahrung – wir sorgen dafür, dass Ihr Fahrzeug wieder einwandfrei funktioniert.
                </p>
            </div>
            </div>
            <div className="footer-homepage">
                < Footer />
            </div>
            <Outlet />
        </section>
    );
};

export default Blog;

/**
 * <div class="hexagon-wrapper">
            <div class="hexagon" id="hexagon-über-uns">
                <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
            </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/kontakt" class="link">Kontakt</Link></i>
                </div>
            </div>
 */